var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTransferGrey = function SvgIconTransferGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-transfer-grey_svg__a",
    d: "M0 .001h15.25V16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-transfer-grey_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-transfer-grey_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M13.25 11.99c0 .62-.51 1.13-1.13 1.13H3.13c-.62 0-1.13-.51-1.13-1.13V3.97A2.97 2.97 0 0 1 4.97 1h5.31a2.97 2.97 0 0 1 2.97 2.97v8.02zm-1.13 2.76c0 .27-.5.27-.5 0v-.63h.5v.63zm-8.5 0c0 .27-.5.27-.5 0v-.63h.5v.63zM14.25 2.87c-.05 0-.1 0-.15.02-.47-1.67-2-2.89-3.82-2.89H4.97C3.15 0 1.62 1.22 1.15 2.89c-.05-.02-.1-.02-.15-.02-.55 0-1 .45-1 1v2.5c0 .55.45 1 1 1v4.62c0 .8.45 1.51 1.12 1.87v.89c0 .68.57 1.25 1.26 1.25.68 0 1.24-.57 1.24-1.25v-.63h6v.63c0 .68.57 1.25 1.26 1.25.68 0 1.24-.57 1.24-1.25v-.89c.67-.35 1.13-1.06 1.13-1.87V7.37c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1z",
    mask: "url(#icon-transfer-grey_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M4.01 7.993h7.904l-.376-4.498H4.451L4.01 7.993zm8.448 1h-9a.503.503 0 0 1-.498-.549l.54-5.498a.5.5 0 0 1 .498-.45h8c.26 0 .477.198.498.457l.46 5.498a.5.5 0 0 1-.498.542zm-7.5 2.002a1 1 0 1 1-2 0 1 1 0 0 1 2 0m8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  }))));
};
export default SvgIconTransferGrey;